import React from 'react';
import { useDispatch } from 'react-redux';

import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import FormCreateThread from '../components/forum/thread/FormCreateThread';

import {
  BG_COLOR_BLACK, ICON_SUCCESS, TEXT_MODAL_ADD, TITLE_MODAL_ADD, URL_HOME, WHITE_COLOR,
} from '../utils/common/constant';
import { asyncCreateThread } from '../middleware/thread/action';

const AddThreadPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onAddThreadHandler = ({ title, body, category }) => {
    dispatch(asyncCreateThread({ title, body, category }));

    Swal.fire({
      icon: ICON_SUCCESS,
      title: TITLE_MODAL_ADD,
      text: TEXT_MODAL_ADD,
      color: WHITE_COLOR,
      background: BG_COLOR_BLACK,
    }).then(() => {
      navigate(URL_HOME);
    }).catch((error) => {
      console.log(error);
    });
  };

  return (
    <FormCreateThread createThread={onAddThreadHandler} />
  );
};

export default AddThreadPage;
